import { render } from "./WorkPage.vue?vue&type=template&id=653da67c&scoped=true"
import script from "./WorkPage.vue?vue&type=script&lang=js"
export * from "./WorkPage.vue?vue&type=script&lang=js"

import "./WorkPage.vue?vue&type=style&index=0&id=653da67c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-653da67c"]])

export default __exports__